import React from 'react'
import ReactDOM from 'react-dom/client'
import AdminApp from './App.tsx'
import '../../index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AdminApp />
  </React.StrictMode>,
)
